export default __webpack_public_path__ + "static/MEDIA_CARNE_ASADA-c49439db816b17e412c8857e7bcac20b.jpg";